import React, { useState, useEffect } from "react";

import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Paper,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getEmployees,
  deleteEmployee,
  createEmployee,
  updateEmployee,
  getReportingMangerList,
} from "../../api/employee";
import { handleAxiosError } from "../../config/action-config";

import { employeesTable as tableDef } from "../../config/grid-columns-defs";
import ControlledTable from "../../component/ControlledTable";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import UpdateDialog from "../../component/UpdateDialog";
import CreateDialog from "../../component/CreateDialog";
import { showAlert } from "../../actions/alert";
import { useForm, Controller } from "react-hook-form";
import BetterControlledTable from "../../component/BetterControlledTable";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { makeStyles } from "@material-ui/core";
const emptyUpdateData = {
  email: "",
  firstname: "",
  lastname: "",
  address: "",
  contact: "",
  role: "",
  cost_rate: "",
  department: "",
  joining_date: "",
  // bill_rate: "",
};

const emptyNewEmployeeData = {
  email: "",
  password: "",
  firstname: "",
  lastname: "",
  contact: "",
  role: "",
  reportingmanager: "",
  joining_date: "",
  address: "",
  // bill_rate: "",
  // cost_rate: "",
};

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function Employee() {
  const classes = useStyles();
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogeOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);
  const [updateData, setUpdateData] = useState(emptyUpdateData);

  const [reportingManager, setReportingManagerList] = useState([]);
  useEffect(() => {
    reportingManagerList();
  }, []);

  const onNewProjectSubmit = (data) => {
    // createEmployee(newEmployeeData, user.token)
    console.log("gggdgd--", data);
    // return;
    data.joining_date = createDateAsUTC(data.joining_date);
    createEmployee(data, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        reset();
        // setNewEmployeeData(emptyNewEmployeeData);
        refreshTable();
        setCreateDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "EDIT": {
        setUpdateDialogeOpen(true);
        const up = getUpdatableData(dialogAction.data);
        setUpdateData(up);
        break;
      }
      case "DELETE":
        setDeleteDialogOpen(true);
        break;
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteEmployee(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);

  useEffect(() => {
    if (updateId === -1) return;
    updateEmployee(updateId, updateData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setUpdateId(-1);
        setUpdateData(emptyUpdateData);
        refreshTable();
        setUpdateDialogeOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setUpdateId(-1);
        setUpdateDialogeOpen(false);
      });
  }, [updateId]);

  const changeUpdateData = (e) => {
    setUpdateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const reportingManagerList = () => {
    const token = user.token;
    return getReportingMangerList(token).then((res) => {
      setReportingManagerList(res.data.data.roledata);
    });
  };

  useEffect(() => {
    if (!createDialogOpen) {
      reset();
      // setNewEmployeeData(emptyNewEmployeeData);
    }
  }, [createDialogOpen]);

  const [queryFilters, setQueryFilters] = useState({
    firstname: "",
    role: "",
    employment_status: "",
  });
  function onQueryFilterChange({ target }) {
    const { name, value } = target;
    console.log("target--", name, value);
    setQueryFilters((prev) => ({ ...prev, [name]: value }));
  }
  const [employeeTableRefreshCount, setEmployeeTableRefreshCount] = useState(0);
  async function getEmployeeTableData(limit, offset) {
    try {
      const { data } = await getEmployees(
        { limit, offset, sort: "desc", ...queryFilters },
        user.token
      );
      let filtersApplied = Object.keys(queryFilters).some(
        (k) => queryFilters[k]
      );
      return {
        rows: data.data,
        // total: filtersApplied ? data.data.length : data.total,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  function refreshTable(e) {
    e?.preventDefault();
    setEmployeeTableRefreshCount((prev) => prev + 1);
  }
  useEffect(() => {
    refreshTable();
  }, [queryFilters.employment_status]);
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Resources In Company
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
        >
          Add Resource
        </Button>
      </Box>
      <br />
      <Box
        component="form"
        onChange={refreshTable}
        // sx={{ px: 2, pb: 2, display: "flex", columnGap: 1 }}

        className="pmt-filter-box"
      >
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item md={3} sm={4} xs={12}>
            <TextField
              size="small"
              label="Resource Name"
              name="firstname"
              value={queryFilters.firstname}
              onChange={onQueryFilterChange}
              fullWidth
            />
          </Grid>
          {/* <div style={{ width: 10 }}></div> */}
          <Grid item md={3} sm={4} xs={12}>
            <TextField
              size="small"
              label="Role"
              name="role"
              value={queryFilters.role}
              onChange={onQueryFilterChange}
              fullWidth
            />
          </Grid>
          <Grid item md={3} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Employment Status
              </InputLabel>
              <Select
                className={classes.textfeild}
                name="employment_status"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={queryFilters.employment_status}
                label="Employment Status"
                size="small"
                sx={{ background: "#fff" }}
                onChange={onQueryFilterChange}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Current-Employee">Current-Resource</MenuItem>
                <MenuItem value="Ex-Employee">Ex-Resource</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* <Button variant="contained" size="small" type="submit" >Search</Button> */}
      </Box>
      <div className="">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getEmployeeTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={employeeTableRefreshCount}
        />
      </div>
      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
      <UpdateDialog
        open={updateDialogOpen}
        setOpen={setUpdateDialogeOpen}
        setUpdateId={setUpdateId}
        rowId={dialogAction.data?.id}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="email"
              fullWidth
              value={updateData.email}
              onChange={changeUpdateData}
              label="Email"
              type="email"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="firstname"
              fullWidth
              value={updateData.firstname}
              onChange={changeUpdateData}
              label="First Name"
              className="name-textfeild"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="lastname"
              fullWidth
              value={updateData.lastname}
              onChange={changeUpdateData}
              label="Last Name"
              className="name-textfeild"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="contact"
              fullWidth
              error={!/^[0-9]{10}$/.test(updateData.contact)}
              value={updateData.contact}
              onChange={changeUpdateData}
              // onChange={changeUpdateData}
              label="Contact"
              type="tel"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            {/* <TextField
              margin="dense"
              name="role"
              fullWidth
              value={updateData.role}
              onChange={changeUpdateData}
              label="Role"
              type="text"
              variant="outlined"
        />*/}
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Role</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="role"
                id="demo-simple-select"
                value={updateData.role}
                label="Role"
                onChange={changeUpdateData}
              >
                <MenuItem value={"Admin"}>Admin</MenuItem>
                <MenuItem value={"ReportingManager"}>
                  Reporting Manager
                </MenuItem>
                <MenuItem value={"Support"}>Support</MenuItem>
                <MenuItem value={"User"}>User</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="bill_rate"
              fullWidth
              value={updateData.bill_rate}
              onChange={changeUpdateData}
              label="Bill Rate"
              type="number"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="cost_rate"
              fullWidth
              value={updateData.cost_rate}
              onChange={changeUpdateData}
              label="Cost Rate"
              type="number"
              variant="outlined"
            />
          </Grid> */}
          <Grid item xs={12} md={12}>
            <TextField
              margin="dense"
              name="address"
              fullWidth
              value={updateData.address}
              onChange={changeUpdateData}
              label="Address"
              type="text"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </UpdateDialog>
      <CreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={handleSubmit(onNewProjectSubmit)}
      >
        <form onSubmit={handleSubmit(onNewProjectSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="email"
                fullWidth
                // value={newEmployeeData.email}
                // onChange={changeNewEmployeeData}
                label="Email"
                type="email"
                inputRef={register({
                  required: "Email Address  is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                required
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="password"
                fullWidth
                // value={newEmployeeData.password}
                // onChange={changeNewEmployeeData}
                label="Password"
                type="password"
                variant="outlined"
                inputRef={register({
                  required: "Password is required.",
                  validate: (value) =>
                    value.length > 4 || "Password is not valid",
                })}
                required
                error={Boolean(errors.password)}
                helperText={errors.password?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="employeeid"
                fullWidth
                // value={newEmployeeData.email}
                // onChange={changeNewEmployeeData}
                label="Employee Id"
                inputRef={register({
                  required: "Employee Id is required.",
                })}
                required
                error={Boolean(errors.employeeid)}
                helperText={errors.employeeid?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="firstname"
                fullWidth
                // value={newEmployeeData.firstname}
                // onChange={changeNewEmployeeData}
                label="First Name"
                className="name-textfeild"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "First Name is required.",
                })}
                required
                error={Boolean(errors.firstname)}
                helperText={errors.firstname?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="lastname"
                fullWidth
                // value={newEmployeeData.lastname}
                // onChange={changeNewEmployeeData}
                label="Last Name"
                className="name-textfeild"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                })}
                // error={Boolean(errors.lastname)}
                // helperText={errors.lastname?.message}
              />
              {/* {errors.lastname && <p>Last name is required.</p>} */}
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="contact"
                fullWidth
                // error={!/^[0-9]{10}$/.test(newEmployeeData.contact)}
                // value={newEmployeeData.contact}
                inputProps={{ maxLength: 10 }}
                // onChange={changeNewEmployeeData}
                // onChange={changeNewEmployeeData}
                label="Contact"
                type="tel"
                inputRef={register({
                  required: "Contact Number is required.",
                  validate: (value) =>
                    value.length > 9 || "Please enter a valid number",
                })}
                required
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <FormControl
                margin="dense"
                fullWidth
                error={Boolean(errors.joining_date)}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        // shouldDisableDate={disablePrevDates(
                        //   dayjs(new Date()).subtract(1, "days").toJSON()
                        // )}
                        label="Joining Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.joining_date)}
                            {...params}
                            minDate={new Date()}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: "Joining Date is required.",
                    }}
                    name="joining_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>{errors.joining_date?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                margin="dense"
                required
                error={Boolean(errors.role)}
              >
                <InputLabel id="demo-simple-select-label">Role</InputLabel>

                <Controller
                  render={(props) => (
                    <Select value={props.value || ""} onChange={props.onChange}>
                      {user.role === "ReportingManager"
                        ? [
                            <MenuItem key="support" value={"Support"}>
                              Support
                            </MenuItem>,
                            <MenuItem key="user" value={"User"}>
                              User
                            </MenuItem>,
                          ]
                        : [
                            <MenuItem key="admin" value={"Admin"}>
                              Admin
                            </MenuItem>,
                            <MenuItem
                              key="reportingManager"
                              value={"ReportingManager"}
                            >
                              Reporting Manager
                            </MenuItem>,
                            // <MenuItem key="salesperson" value={"SalesPerson"}>
                            //   SalesPerson
                            // </MenuItem>,

                            <MenuItem key="support" value={"Support"}>
                              Support
                            </MenuItem>,
                            <MenuItem key="user" value={"User"}>
                              User
                            </MenuItem>,
                          ]}
                    </Select>
                  )}
                  name="role"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please choose your Role.",
                  }}
                />
                <FormHelperText>{errors.role?.message}</FormHelperText>
              </FormControl>

              {/* <FormControl
                fullWidth
                margin="dense"
                error={Boolean(errors.role)}
                helperText={errors.role?.message}
              >
                <InputLabel id="demo-simple-select-label">Role</InputLabel>

                <Select
                  labelId="demo-simple-select-label"
                  name="role"
                  id="demo-simple-select"
                  // value={newEmployeeData.role}
                  label="Role"
                  // onChange={changeNewEmployeeData}
                  {...register("role", {
                    required: "Role is required.",
                  })}
                >
                  <MenuItem value={"Admin"}>Admin</MenuItem>
                  <MenuItem value={"User"}>User</MenuItem>
                  <MenuItem value={"ReportingManager"}>
                    ReportingManager
                  </MenuItem>
                  <MenuItem value={"Support"}>Support</MenuItem>
                </Select>
              </FormControl> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                margin="dense"
                required
                error={Boolean(errors.department)}
              >
                <InputLabel id="demo-simple-select-label">
                  Department
                </InputLabel>

                <Controller
                  render={(props) => (
                    <Select value={props.value || ""} onChange={props.onChange}>
                      <MenuItem value={"Development"}>Development</MenuItem>,
                      <MenuItem value={"Infrastructure"}>
                        Infrastructure
                      </MenuItem>
                      ,<MenuItem value={"Finance"}>Finance</MenuItem>,
                      <MenuItem value={"Hr"}>HR</MenuItem>,
                      <MenuItem value={"Sales"}>Sales</MenuItem>,
                      <MenuItem value={"Marketing"}>Marketing</MenuItem>,
                    </Select>
                  )}
                  name="department"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please choose your department.",
                  }}
                />
                <FormHelperText>{errors.department?.message}</FormHelperText>
              </FormControl>

              {/* <FormControl
                fullWidth
                margin="dense"
                error={Boolean(errors.role)}
                helperText={errors.role?.message}
              >
                <InputLabel id="demo-simple-select-label">Role</InputLabel>

                <Select
                  labelId="demo-simple-select-label"
                  name="role"
                  id="demo-simple-select"
                  // value={newEmployeeData.role}
                  label="Role"
                  // onChange={changeNewEmployeeData}
                  {...register("role", {
                    required: "Role is required.",
                  })}
                >
                  <MenuItem value={"Admin"}>Admin</MenuItem>
                  <MenuItem value={"User"}>User</MenuItem>
                  <MenuItem value={"ReportingManager"}>
                    ReportingManager
                  </MenuItem>
                  <MenuItem value={"Support"}>Support</MenuItem>
                </Select>
              </FormControl> */}
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                margin="dense"
                required
                error={Boolean(errors.reportingmanager)}
              >
                <InputLabel id="demo-simple-select-label">
                  Reporting Manager
                </InputLabel>

                <Controller
                  render={(props) => (
                    <Select value={props.value || ""} onChange={props.onChange}>
                      <MenuItem value="">Select</MenuItem>
                      {reportingManager.map((r, i) => (
                        <MenuItem key={i} value={r.email}>
                          {r.email}
                        </MenuItem>
                      ))}
                      <MenuItem value="None">None</MenuItem>
                    </Select>
                  )}
                  name="reportingmanager"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please choose your Reporting Manager.",
                  }}
                />
                <FormHelperText>
                  {errors.reportingmanager?.message}
                </FormHelperText>
              </FormControl>
              {/* <FormControl fullWidth margin="dense">
                <InputLabel id="demo-simple-select-label">
                  Reporting Manager
                </InputLabel>

                <Select
                  labelId="demo-simple-select-label"
                  name="reportingmanager"
                  id="demo-simple-select"
                  // value={newEmployeeData.reportingmanager}
                  label="ReportingManager"
                  // onChange={changeNewEmployeeData}
                  {...register("reportingmanager", {
                    required: "Reporting Manager is required.",
                  })}
                  error={Boolean(errors.reportingmanager)}
                  helperText={errors.reportingmanager?.message}
                >
                  <MenuItem value="">Select</MenuItem>
                  {reportingManager.map((r, i) => (
                    <MenuItem key={i} value={r.email}>
                      {r.email}
                    </MenuItem>
                  ))}
                  <MenuItem value="None">None</MenuItem>
                </Select>
              </FormControl> */}
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="bill_rate"
                fullWidth
                // value={newEmployeeData.bill_rate}
                // onChange={changeNewEmployeeData}
                label="Bill Rate"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: "Bill Rate is required.",
                })}
                error={Boolean(errors.bill_rate)}
                helperText={errors.bill_rate?.message}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="cost_rate"
                fullWidth
                // value={newEmployeeData.cost_rate}
                // onChange={changeNewEmployeeData}
                label="Cost Rate ($)"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: "Cost Rate is required.",
                })}
                required
                error={Boolean(errors.cost_rate)}
                helperText={errors.cost_rate?.message}
              />
            </Grid> */}

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="address"
                fullWidth
                // value={newEmployeeData.address}
                // onChange={changeNewEmployeeData}
                label="Address"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Address is required.",
                })}
                required
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                margin="dense"
                required
                error={Boolean(errors.employment_status)}
              >
                <InputLabel id="demo-simple-select-label">
                  Employment Status
                </InputLabel>

                <Controller
                  render={(props) => (
                    <Select value={props.value || ""} onChange={props.onChange}>
                      <MenuItem value="">Select</MenuItem>

                      <MenuItem value="Current-Employee">
                        Current-Employee
                      </MenuItem>

                      <MenuItem value="Ex-Employee">Ex-Employee</MenuItem>
                    </Select>
                  )}
                  name="employment_status"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please choose your employment status.",
                  }}
                />
                <FormHelperText>
                  {errors.employment_status?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="designation"
                fullWidth
                // value={newEmployeeData.address}
                // onChange={changeNewEmployeeData}
                label="Designation"
                type="text"
                variant="outlined"
                inputRef={register({
                  // required: "Designation is required.",
                  required: false,
                })}
                // required
                error={Boolean(errors.designation)}
                helperText={errors.designation?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="job_title"
                fullWidth
                // value={newEmployeeData.address}
                // onChange={changeNewEmployeeData}
                label="Job Title"
                type="text"
                variant="outlined"
                inputRef={register({
                  // required: "Job Title is required.",
                  required: false,
                })}
                // required
                error={Boolean(errors.job_title)}
                helperText={errors.job_title?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="job_location"
                fullWidth
                // value={newEmployeeData.address}
                // onChange={changeNewEmployeeData}
                label="Job Location"
                type="text"
                variant="outlined"
                inputRef={register({
                  // required: "Job Location is required.",
                  required: false,
                })}
                // required
                error={Boolean(errors.job_location)}
                helperText={errors.job_location?.message}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                margin="dense"
                error={Boolean(errors.leave_encashed_date)}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        // shouldDisableDate={disablePrevDates(
                        //   dayjs(new Date()).subtract(1, "days").toJSON()
                        // )}
                        label="Leave Encashed Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.leave_encashed_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: false,
                      // required: "Leave Encashed Date is required.",
                    }}
                    name="leave_encashed_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>
                  {errors.leave_encashed_date?.message}
                </FormHelperText>
              </FormControl>
            </Grid> */}
          </Grid>
        </form>
      </CreateDialog>
    </Box>
  );
}

function getUpdatableData(data) {
  return {
    email: data.email,
    department: data.department,
    firstname: data.firstname,
    lastname: data.lastname,
    address: data.address,
    contact: data.contact,
    role: data.role,
    cost_rate: data.cost_rate,
    bill_rate: data.bill_rate,
  };
}
function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}
